import styled from 'styled-components';
import { ColorPalette } from 'theme/colors';

export const DetailCard = styled.div`
  border-radius: 16px;
  box-shadow: 0 2px 16px 0 ${({ theme }) => theme.hotelDetails.detailCard};
  background-color: ${({ theme }) => theme.hotelDetails.background};
`;

interface InfoProps {
  $seeMore?: boolean;
}

export const InfoContainer = styled.div`
  padding: 16px 24px;
`;

export const Info = styled.div<InfoProps>`
  font-size: 14px;
  line-height: 1.5;
  color: ${ColorPalette.HEX.DimGray};

  ${({ $seeMore }) => {
    if (!$seeMore) {
      return `
        display: -webkit-box;
        -webkit-line-clamp: 3;
        -webkit-box-orient: vertical;
        overflow: hidden;
        text-overflow: ellipsis;
      `;
    }
  }}
`;
